import { Card } from "../components/common/Card";

const programs = [
  { title: "Faith in Action", text: "We support individuals on their journey of faith, healing, and self-discovery by nurturing inner growth, encouraging reflection, and helping people discover purpose, identity, and hope. Through mentorship, prayerful support, and compassionate relationships, we walk alongside individuals as they grow spiritually, emotionally, and personally." },
  { title: "Compassionate Outreach & Practical Support", text: "We address real-life challenges by meeting practical needs, supporting vulnerable individuals and families, and offering care that reflects Christ’s compassion and deep respect for human dignity." },
  { title: "Empowerment & Life Development", text: "We help individuals build confidence, resilience, and purpose through guidance, encouragement, and empowerment initiatives that promote independence, stability, and long-term wellbeing." },
  { title: "Community & Relationship Building", text: "We work within communities to strengthen connections, restore trust, and promote unity recognizing that transformed lives contribute to stronger, healthier communities." },
];

export default function Programs() {
  return (
    <section className="py-20 px-6 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold mb-12 text-center text-[#2D033B]">
        Our Programs
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {programs.map((prog) => (
          <Card key={prog.title} title={prog.title} text={prog.text} />
        ))}
      </div>
    </section>
  );
}
